import { useState, useEffect } from 'react';

export const useScript = (url) => {
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        if (document.querySelector(`script[src="${url}"]`)) {
            setLoaded(true);
            return;
        }
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.onload = () => setLoaded(true);
        if (script) {
            document.body.appendChild(script);
        }
    }, [url]);
    return loaded;
};